module.exports = __webpack_public_path__ + "static/img/egg_r_12.911b11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_12.png
// module id = U2WC
// module chunks = 1